(function () {
  function initTrack(track) {
    if (track.dataset.hiwInit === '1') return;
    track.dataset.hiwInit = '1';
    var id = track.id.replace('hiw-track-', '');
    var arrows = document.getElementById('hiw-arrows-' + id);
    var root = document.getElementById('hiw-' + id);
    if (!arrows || !root) return;
    var prev = arrows.querySelector('.eb__arrow--prev');
    var next = arrows.querySelector('.eb__arrow--next');
    if (!prev || !next) return;

    function layoutGrid() {
      return root.classList.contains('hiw--layout-responsive') && window.matchMedia('(min-width: 990px)').matches;
    }

    function slideW() {
      var card = track.querySelector('.hiw__card');
      if (!card) return track.clientWidth || 440;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function maxScrollLeft() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }
    function atStart() {
      return track.scrollLeft <= 2;
    }
    function atEnd() {
      return track.scrollLeft >= maxScrollLeft() - 2;
    }

    function go(dir) {
      if (layoutGrid()) return;
      var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      if (isMobile) {
        if (dir > 0 && atEnd()) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }
        if (dir < 0 && atStart()) {
          track.scrollTo({ left: maxScrollLeft(), behavior: 'smooth' });
          return;
        }
      }
      track.scrollBy({ left: dir * slideW(), behavior: 'smooth' });
    }

    prev.addEventListener('click', function () {
      go(-1);
    });
    next.addEventListener('click', function () {
      go(1);
    });

    track.addEventListener('keydown', function (e) {
      if (layoutGrid()) return;
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        go(-1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        go(1);
      }
    });
  }

  document.querySelectorAll('[id^="hiw-track-"]').forEach(initTrack);
})();
